import React from 'react';

const ProgressBar = ({ 
  value, 
  max = 100, 
  color = '#ff660e',
  label = '',
  showPercentage = true,
  height = 'h-2'
}) => {
  const percentage = Math.min((value / max) * 100, 100);
  
  return (
    <div className="w-full">
      {label && (
        <div className="flex justify-between text-sm mb-1">
          <span className="text-gray-700">{label}</span>
          {showPercentage && (
            <span className="font-medium">{percentage.toFixed(1)}%</span>
          )}
        </div>
      )}
      
      <div className={`w-full ${height} bg-gray-200 rounded-full overflow-hidden`}>
        <div 
          className="h-full rounded-full transition-all duration-500"
          style={{ 
            width: `${percentage}%`,
            backgroundColor: color
          }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;